import React from 'react';
import {
  makeStyles,
  FormControl,
  FormGroup,
  FormLabel,
  FormHelperText
} from '@material-ui/core';
import { Checkbox } from 'components/Forms';
import { DayOfWeek } from 'models/Adjustment';
import { FieldInputProps, FieldMetaState } from 'react-final-form';
import clsx from 'clsx';
import { InputFieldProps } from './utils';
import { formStyles } from './styles';

const useStyles = makeStyles(
  theme => ({
    wrapper: {
      '& [class*="MuiFormLabel-root"].Mui-focused': {
        color: theme.palette.aegis.semantic.message.black
      },
      '& .Mui-focusVisible': {
        color: theme.palette.primary.main
      },
      display: 'flex',
      alignItems: 'flex-end'
    },
    dayList: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'baseline',
      width: 400
    }
  }),
  {
    name: 'Weekdays'
  }
);

export const weekdays = (Object.values(DayOfWeek) as DayOfWeek[]).filter(
  day => day !== DayOfWeek.Sunday
);

const Weekdays = ({
  field,
  input,
  meta
}: {
  field: InputFieldProps;
  input: FieldInputProps<string, HTMLElement>;
  meta: FieldMetaState<string | number>;
}) => {
  const classes = useStyles();
  const formClasses = formStyles();
  // conversion required because Weekdays is only called with string instead of Record
  const { value, onChange } = (input as unknown) as FieldInputProps<
    Record<DayOfWeek, boolean>,
    HTMLElement
  >;

  const handleCheckboxChange = (day: DayOfWeek) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onChange({ ...value, [day]: event.target.checked });
    input.onBlur();
  };

  return (
    <FormControl
      component="fieldset"
      className={clsx('weekdays', classes.wrapper)}
    >
      <FormLabel component="legend">{field.label}</FormLabel>
      <FormGroup className={classes.dayList}>
        {weekdays.map(day => (
          <Checkbox
            key={day}
            className={formClasses.field}
            field={{
              label: day.charAt(0) + day.slice(1).toLowerCase(),
              name: `${input.name}.${day}`,
              qaId: day
            }}
            checked={Boolean(value?.[day])}
            onChange={handleCheckboxChange(day)}
            meta={{ ...meta, error: undefined }}
          />
        ))}
        {meta.touched && meta.error && (
          <FormHelperText error>{meta.error}</FormHelperText>
        )}
      </FormGroup>
    </FormControl>
  );
};

export default Weekdays;
